import { type HomepageHeroStoryblok } from '~/types/generated'
import { type HeroProps } from './Hero.interface'

export const mapHero = (story: HomepageHeroStoryblok): HeroProps => {
  const title = story.title ?? null
  const text = story.text ?? null

  return {
    title,
    text
  }
}
